// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1205": "5305188597d2","3639": "0f99df612d6a","906": "7dfb04466928",}[chunkId] + ".css"
}